import { updateSearchManager } from './types';

export const requestUpdateSearchManager = (fundingSearchId, userId) => ({
  type: updateSearchManager.request,
  fundingSearchId,
  userId,
});
export const requestUpdateSearchManagerSuccess = (fundingSearchId, response) => ({
  type: updateSearchManager.success,
  fundingSearchId,
  response,
});
export const requestUpdateSearchManagerFailure = (fundingSearchId, error) => ({
  type: updateSearchManager.failure,
  fundingSearchId,
  error,
});
